import { AddressLookupSummary } from './address-lookup-summary';

export interface AddressLookupResponse {
  suggestions: AddressLookupSummary[];
}
